export default __webpack_public_path__ + "static/media/wait.89c8da97.svg";